export const getUserFullName = (user: {
  firstName?: string | null;
  lastName?: string | null;
}) => {
  return user.firstName + (user.lastName ? ` ${user.lastName}` : "");
};
